import { createContextQuick } from '@components/quick-context';
import { scrollToElement, withScrollSpyItem } from '@components/scroll-spy';
import { createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { forwardRef, useCallback, useRef } from 'react';
import { Control, useController, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
// import { CompanyForm, InputCompanyDetail } from './company.types';

// export interface CompanyFormProps {
//   edit?: boolean;
//   company?: InputCompanyDetail;
// }

// export interface CompanyFormInternalState {
//   triggerSubmit?: () => any;
//   companyForm?: CompanyForm;
// }

// export const [CompanyFormStateProvider, useCompanyFormState] =
//   createContextQuick<CompanyFormProps & CompanyFormInternalState>();

export const useFocusableDiv = (offset = 160) => {
  const divRef = useRef<HTMLDivElement>();
  const focus = useCallback(
    () => divRef.current && scrollToElement(divRef.current, offset),
    [divRef, offset]
  );
  return { divRef, focus };
};

export interface FormFieldProps {
  name: string;
  control: Control;
  [k: string]: any;
}

export const createFormField =
  (
    InnerComponent: React.ComponentType<{ value: any; onChange: any }>,
    { defaultValue = null, passProps = false }: { defaultValue?: any; passProps?: boolean } = {}
  ) =>
  ({ name, control, ...otherProps }: FormFieldProps) => {
    const { divRef, focus: onFocus } = useFocusableDiv();
    const {
      field: { value, onChange },
    } = useController({ name, control, defaultValue, onFocus });
    const passingProps = passProps ? otherProps : {};
    return (
      <div ref={divRef}>
        <InnerComponent value={value} onChange={onChange} {...passingProps} />
      </div>
    );
  };

export const ScrollSpyTitle = withScrollSpyItem(Typography);

interface TitleProps {
  title: React.ReactNode;
  subTitle: React.ReactNode;
  icon: React.ReactNode;
}

// export const SectionTitle = withScrollSpyItem(
//   forwardRef(
//     (
//       {
//         title,
//         icon,
//         subTitle,
//         id,
//         fabIcons = null,
//       }: TitleProps & { id: string; fabIcons?: React.ReactNode },
//       ref: any
//     ) => (
//       <Grid
//         container
//         ref={ref}
//         id={id}
//         justify="space-between"
//         style={{ marginRight: '20px' }}
//         alignItems="center">
//         <Grid item>
//           <Grid item style={{ display: 'flex' }} spacing={2} alignItems="center">
//             <Grid item style={{ paddingRight: '10px' }}>
//               {icon}
//             </Grid>
//             <Grid item>
//               <Typography variant="h5">{title}</Typography>
//               <Typography color="textSecondary" variant="body2">
//                 {subTitle}
//               </Typography>
//             </Grid>
//           </Grid>
//         </Grid>
//         {fabIcons && <Grid item>{fabIcons}</Grid>}
//       </Grid>
//     )
//   )
// );

export const SubSectionTitle = ({ title, subTitle, icon }: TitleProps) => {
  const classes = useSubSectionTitleStyles();
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item>{icon}</Grid>
      <Grid item>
        <Typography variant="h5" className={classes.subSectionTitle}>
          {title}
        </Typography>
        <Typography color="textSecondary" variant="body2">
          {subTitle}
        </Typography>
      </Grid>
    </Grid>
  );
};

const useSubSectionTitleStyles = makeStyles(() =>
  createStyles({
    subSectionTitle: {
      fontSize: 16,
    },
  })
);


